export default __webpack_public_path__ + "static/media/c2.e4f7fd68.jpg";